export function configureMdGestureProvider($mdGestureProvider) {
    'ngInject';

    // For mobile devices without jQuery loaded, do not
    // intercept click events during the capture phase.
    $mdGestureProvider.skipClickHijack();
}



// WEBPACK FOOTER //
// ./src/lib/providers/md-gesture-provider.config.ts